const buildElement = <T = HTMLElement>(html: string) => {
  const template = document.createElement('template')
  template.innerHTML = html
  return template.content.firstElementChild as T
}

export default buildElement
